
import axios from '../../config/axiosConfig';
import { BANK_PAYMENT_TRANSACTION_REQUEST, BANK_PAYMENT_TRANSACTION_REQUEST_FAILURE, GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_PAYMENT_TRANSACTIONS, GET_BANK_PAYMENT_TRANSACTIONS } from '../types';

export const getBankPaymentTransactions = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BANK_PAYMENT_TRANSACTION_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };
            return axios.get('/bank-payment-transaction/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BANK_PAYMENT_TRANSACTIONS, payload: response.data });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BANK_PAYMENT_TRANSACTION_REQUEST_FAILURE, error: error.message });    
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BANK_PAYMENT_TRANSACTION_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getAllAccountIdWiseConsigneeBankPaymentTransactions = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };

      return axios.get("/bank-payment-transaction/get-account-id-wise-consignee", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_PAYMENT_TRANSACTIONS, payload: response?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_TRANSACTION_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};
